import type {SubmitEvent} from 'react'
import {Input} from '@freckle/educator-entities/ts/common/components/base/input'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {SpinnerOverlay} from '@freckle/educator-materials/ts/components/spinner'
import {H1} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {CenteredPage} from '@freckle/school/ts/common/components/common/centered-page'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import Success from '@freckle/school/ts/pages/forgot-password/success'
import * as style from './forgot-password.module.scss'

type Props = {
  email?: string
  onChangeEmail: (email: string) => void
  onSubmitLogin: (e: SubmitEvent<HTMLFormElement>) => void
  loading: boolean
  showSuccess: boolean
}

export function ForgotPassword(props: Props) {
  const {t} = useSafeTranslation()
  const {email, onChangeEmail, onSubmitLogin, loading, showSuccess} = props

  if (loading) {
    return <SpinnerOverlay />
  }

  if (showSuccess) {
    return <Success />
  }

  return (
    <CenteredPage>
      <H1>{t('FORGOT_PASSWORD_PAGE_TITLE')}</H1>
      <form action="" method="post" onSubmit={onSubmitLogin} className={style.form}>
        <p>{t('FORGOT_PASSWORD_PAGE_DESCRIPTION_TEXT')}</p>
        <div className={style.formGroup}>
          <Input
            className="form-control"
            name="email"
            onChange={onChangeEmail}
            type="email"
            placeholder={t('FORGOT_PASSWORD_PAGE_EMAIL_PLACEHOLDER_TEXT')}
            autoCorrect="off"
            required
            value={email}
            dataTest="forgot-password-email-input"
          />
        </div>
        <Button style="primary" type="submit" dataTest="forgot-password-submit-btn">
          {t('FORGOT_PASSWORD_PAGE_BUTTON_TEXT')}
        </Button>
      </form>
      <div className={style.footer}>
        <Link href={Routes.login()} reactRouter>
          {t('FORGOT_PASSWORD_PAGE_BACK_LOGIN_LINK_TEXT')}
        </Link>
      </div>
    </CenteredPage>
  )
}
